import { GET_EDUCATION_LEVELS } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_EDUCATION_LEVELS] (state, educationLevels) {
    state.all = educationLevels
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/educationLevels.js